// A billing period (cycle) can't take a payment before its own month: a
// 5 Nov – 4 Dec cycle opens on 1 Nov. Mirrors api-server/src/lib/period-payable.ts
// (the server enforces it; this keeps Collect from queuing future cycles).

function istToday(): string {
  return new Date(Date.now() + 5.5 * 3600 * 1000).toISOString().slice(0, 10);
}

export function isPeriodPayable(periodStart: string, today: string = istToday()): boolean {
  return today >= `${periodStart.slice(0, 7)}-01`;
}

/** Server message from an ApiError ("HTTP 422 …: <message>"), for toasts. */
export function apiErrorDetail(err: unknown): string | undefined {
  const msg = (err as Error | undefined)?.message ?? "";
  const i = msg.indexOf(": ");
  return i >= 0 ? msg.slice(i + 2) : undefined;
}
